<template>
  <div v-if="!loading" style="padding: 0 !important;">
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Expediente N° {{ expediente.code }}</v-toolbar-title>
      <CerrarExpedienteDialog v-if="!this.$store.getters.isClubRole" :expediente="expediente"
        ref="cerrarExpedienteDialog">

      </CerrarExpedienteDialog>
      <MovimientoPopUpCreate v-if="!this.$store.getters.isClubRole" ref="movimientoCreate" :expediente="expediente">
      </MovimientoPopUpCreate>
      <MovimientoPopUpCreateClub v-if="this.$store.getters.isClubRole" ref="movimientoCreate" :expediente="expediente">
      </MovimientoPopUpCreateClub>
      <v-spacer></v-spacer>
      <div style="display: flex; justify-content: end;">
        <v-btn color="blue-grey-lighten-4" @click="goBack">Volver</v-btn>
        <v-btn v-if="expediente.state !== 'Cerrado' && this.$store.state.permissions.canCloseExpediente" dark
          color="#EF5350" @click="cerrarExpediente">Cerrar expediente</v-btn>
        <v-btn v-if="expediente.state !== 'Cerrado' && this.$store.state.permissions.canAddMovimiento" app dark
          color=primary @click="createMovimiento">Crear movimiento</v-btn>
      </div>

    </v-toolbar>
    <div class="body-content">
      <ExpedienteHeader :expediente="expediente"></ExpedienteHeader>
      <div v-if="$store.getters.loading"></div>
      <div class="datatable-movimientos-container" v-else>
        <DataTable v-if="!this.$store.getters.isClubRole" class="datatable-movimientos" :headers="headers" :path="path"
          :filterPath="filterPath" :properties="properties" action-buttons-name="MovimientosListActionButtons">
        </DataTable>
        <DataTable v-else class="datatable-movimientos" :headers="headers" :path="path" :filterPath="filterPath"
          :properties="properties" action-buttons-name="MovimientosListActionButtonsClub">
        </DataTable>
      </div>
      <br>
    </div>
    <div style="display: flex;">
        <v-btn color="blue-grey-lighten-4" @click="goBack">Volver</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="expediente.state !== 'Cerrado' && this.$store.state.permissions.canAddMovimiento" app dark
          color=primary @click="createMovimiento">Crear movimiento</v-btn>
      </div>
  </div>
</template>

<script>
import ExpedienteHeader from '../components/ExpedienteHeader.vue'
import MovimientoPopUpCreate from '../components/MovimientoPopUpCreate.vue'
import DataTable from '../../../common/ui/DataTable'
import CerrarExpedienteDialog from '../components/CerrarExpedienteDialog.vue'
import MovimientoPopUpCreateClub from '../components/MovimientoPopUpCreateClub.vue'

export default {
  data () {
    return {
      expediente: null,
      loading: true,
      path: null,
      filterPath: null
    }
  },
  components: {
    ExpedienteHeader,
    DataTable,
    MovimientoPopUpCreate,
    CerrarExpedienteDialog,
    MovimientoPopUpCreateClub
  },
  methods: {
    fetchExpediente () {
      this.axios
        .get(`expediente/${this.$route.params.id}`)
        .then(response => {
          this.expediente = response.data
          this.loading = false
          this.path = `expediente/${this.expediente.id}/movimientos`
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    goBack () {
      this.$router.go(-1)
    },
    createMovimiento () {
      this.$refs.movimientoCreate.showDialog()
    },
    cerrarExpediente () {
      this.$refs.cerrarExpedienteDialog.showDialog()
    }
  },
  computed: {
    headers () {
      let headers = [
        { text: 'Fecha', value: 'created' },
        { text: 'Tipo de movimiento', value: 'type' },
        { text: 'Detalle de movimiento', align: 'left', value: 'description' },
        { text: 'Autor', value: 'author' },
        { text: 'Posee adjuntos', value: 'poseeAdjuntos' },
        { text: 'Acciones', align: 'center', sortable: false }
      ]
      return headers
    },
    properties () {
      let properties = ['created', 'type', 'description', 'author', 'poseeAdjuntos']
      return properties
    }
  },
  created () {
    this.$store.commit('pagination/setSearch', '')
  },
  mounted () {
    this.fetchExpediente()
  }
}

</script>

<style scoped>
.body-content {
  padding: 0 0 0 0 !important;
  margin-top: 6em !important;
}

.datatable-movimientos-container {
  display: flex;
  justify-content: center;
}

.datatable-movimientos {
  width: 1200px;
}
</style>
